/**
 * Conversation Service
 *
 * Pure domain logic for immutable conversation operations.
 */
import { emptyConversation } from '../models';
export function addMessage(conversation, message) {
    return {
        ...conversation,
        messages: [...conversation.messages, message],
    };
}
export function updateMessage(conversation, messageId, partial) {
    return {
        ...conversation,
        messages: conversation.messages.map((msg) => msg.id === messageId ? { ...msg, ...partial } : msg),
    };
}
export function setTyping(conversation, isTyping) {
    return {
        ...conversation,
        isTyping,
    };
}
export function setConversationId(conversation, conversationId) {
    return {
        ...conversation,
        conversationId,
    };
}
export function clear() {
    return { ...emptyConversation, messages: [] };
}
export const conversationService = {
    addMessage,
    updateMessage,
    setTyping,
    setConversationId,
    clear,
};
export default conversationService;
